<template>
    <table class="shop_table table total_table cart_sub_total">
        <tbody>
        <tr class="cart-subtotal">
            <th>Subtotal</th>
            <td>
                <span class="price-amount">
                    <bdi>{{ priceFormatter($store.getters.itemsTotalPrice) }}</bdi>
                </span>
            </td>
        </tr>
        <tr class="cart_coupon">
            <td colspan="7" class="actions">
                <div class="coupon">
                    <input type="text" name="coupon_code" class="input-text" v-model="code" placeholder="Coupon code">
                    <button v-on:click="handleGetCoupon" class="apply_btn" name="apply_coupon" value="Apply coupon">Apply coupon</button>
                    <button v-on:click="emptyCart" v-if="isAdmin" class="d-md-block d-none empty_cart">Empty cart</button>
                </div>
            </td>
        </tr>
        <tr v-if="$store.getters.coupon && $store.getters.coupon.amount && $store.getters.itemsTotalPrice > 0" class="coupon-price">
            <th>
                Coupon: {{$store.getters.coupon.code}}
                <span><a href="javascript:" v-on:click="handleRemoveCoupon">[Remove]</a></span>
            </th>
            <td>
                <span class="price-amount">-{{ $store.getters.itemsTotalPrice > $store.getters.coupon.amount ? priceFormatter($store.getters.coupon.amount) : priceFormatter($store.getters.itemsTotalPrice) }}</span>
            </td>
        </tr>
        <tr v-if="$store.getters.coupon && $store.getters.coupon.amount && $store.getters.itemsTotalPrice > 0" class="subtotal-with-coupon">
            <th>Subtotal w/ Coupon</th>
            <td>
                <span class="price-amount">{{priceFormatter($store.getters.subTotalWithCoupon)}}</span>
            </td>
        </tr>
        <tr class="notification-tr">
            <td colspan="2">
                <notifications
                        :target="'shipping'"
                />
            </td>
        </tr>
        <tr class="shipping">
            <th>
                <div class="shipping-title">
                    <p style="color: #fff">Shipping</p>
                </div>
                <div class="shipping-desc desktop_show">
                    <!-- <p style="color: #d0d0d0" v-if="$store.getters.isShippingCalculated">Use the 'Save & Share Cart' button below to have us review your Cart.</p> -->
                    <p style="color: #d0d0d0">Use the 'Save & Share Cart' button below to have us review your Cart.</p>
                </div>
            </th>
            <td>
                <ul  class="shipping_method_list" v-for="rate in $store.getters.shippingRates">
                    <li style="text-align: left" class="d-flex">
                        <input v-if="rate.type !== 'ground_freight'" @change="setCustomPriceInitialValue" type="radio" :value="rate.id" :id="rate.id" :key="`rate_${rate.id}`" class="shipping_methods" v-model="shippingRate">
                        <label :for="rate.id">
                            {{ rate.label }}
                        </label>
                    </li>
                    <li>
                        <p>{{rate.cost && rate.cost > 0 ? priceFormatter(rate.cost) : 'FREE'}}</p>
                    </li>
                </ul>
                <ul class="custom_shipping" v-if="isAdmin && isShippingCalculated">
                    <li>
                        <label>
                            <input type="checkbox" class="checkbox" v-on:change="setCustomPriceInitialValue()" v-model="reset_shipping" name="reset_shipping" value="1" />
                            reset
                        </label>
                    </li>
                    <li>
                        <input type="number"  v-model="shipping_custom_price" class="custom_shipping_qty_update"/>
                    </li>
                </ul>
                <ul class="update" v-if="isAdmin && isShippingCalculated">
                    <li>
                        <button class="update-btn" @click="setShippingCustomPrice()">Update</button>
                    </li>
                </ul>
                <div class="shipping-calculator">

                    <!-- <a href="javascript:" v-if="$store.getters.beforeShippingMethods.shipFree && $store.getters.beforeShippingMethods.shipFree != '0.00'" v-on:click="showCalcShipping = !showCalcShipping" class="shipping-calculator-button">
                        {{$store.getters.isShippingCalculated ? 'Edit Shipping ZIP ' : 'Calculate Shipping* '}}
                        <i class="fas fa-truck"></i>
                    </a> -->
                    <span v-if="$store.getters.beforeShippingMethods.shipFree && $store.getters.beforeShippingMethods.shipFree != '0.00'" class="shipping-calculator-button" style="color: #9daca1;">
                        Enter Shipping ZIP
                        <i class="fas fa-truck"></i>
                    </span>
                    <div class="shipping_box">
                        <!-- <div class="warning-message-box">
                            <span  class="warning-message-icon">
                            <i class="fa fa-exclamation-triangle"></i>
                            </span>
                            <span  class="warning-message">Please calculate your shipping cost</span>
                        </div> -->
                        <section class="shipping-calculator-form" >

                            <!-- <p class="form-row" id="calc_shipping_country_field">
                                <v-select
                                    :options="constants.STATE_LIST" v-model="shipping_methods.state"
                                    :reduce="state => state.code"
                                    :searchable="true"
                                    placeholder="State"
                                />
                            </p> -->

                            <p class="form-row">
                                <input type="text" v-model="shipping_methods.zipcode" class="input-text" placeholder="ZIP" required>
                            </p>

                            <!-- <p class="form-row">
                                <input type="text" v-model="shipping_methods.email" class="input-text" placeholder="Email">
                            </p> -->

                            <p class="form-row">
                                <button type="submit" v-on:click="calcShipping" class="update_btn">Update</button>
                            </p>
                        </section>
                    </div>
                </div>

            </td>
        </tr>
        <tr class="mobile_show">
            <td>
                <div class="shipping-desc">
                    <!-- <p style="color: #d0d0d0" v-if="$store.getters.isShippingCalculated">Use the 'Save & Share Cart' button below to have us review your Cart.</p> -->
                    <p style="color: #d0d0d0">Use the 'Save & Share Cart' button below to have us review your Cart.</p>
                </div>
            </td>
        </tr>

        <tr class="tax-total">
            <th>Tax</th>
            <td data-title="Tax">
                <span class="price-amount">
                    <bdi>
                        <span class="price-currency-symbol">$</span>0.00
                    </bdi>
                </span>
            </td>
        </tr>

        <tr class="order-total">
            <th>Total</th>
            <td>
                <strong>
                    <span class="price-amount total">
                        <bdi>{{ priceFormatter($store.getters.totalPrice) }}</bdi>
                    </span>
                </strong>
            </td>
        </tr>

        </tbody>
    </table>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex"
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import Notifications from "../Notifications";
export default {
    name: 'cart-totals-section',
    components: {Notifications, 'v-select': vSelect},
    data() {
        return {
            showCalcShipping: false,
            shipping_custom_price: null,
            reset_shipping: 0,
            code: null,
            methods : ""
        }
    },
    mounted() {
        this.checkCartItems()
        this.setCustomPriceInitialValue()
    },
    created()
    {
        this.setCustomPriceInitialValue()
    },
    beforeMount() {
        this.beforeCalcGroundFreight();
    },
    computed: {
        ...mapState(['shipping_methods']),...mapGetters(['isAdmin', 'isShippingCalculated', 'shippingPriceWithoutCustom','shippingDefaultPriceWithoutCustom']),
        shippingRate: {
            get () {return this.$store.getters.shippingMethods.selected},
            set (value) {this.$store.commit('SELECT_SHIPPING_RATE', {selected: value})}
        },
    },
    methods: {
        ...mapActions(['cartMinQtyNote',"calculateShipping", 'saveCart', 'removeCoupon', 'emptyNotes', 'emptyCart', 'calcGroundFreight','checkCartItems','beforeCalcGroundFreight','getCoupon']),
        calcShipping() {
            this.checkCartItems()
            this.emptyNotes()
            this.calculateShipping().then(res => {
                // $('.shipping_box').fadeToggle('slow');
                this.saveCart({page: 'cart'})
            })
            this.cartMinQtyNote()
        },
        setCustomPriceInitialValue() {
            this.shipping_custom_price = this.decimalFormatter(this.shippingPriceWithoutCustom);
        },
        handleRemoveCoupon() {
            this.removeCoupon().then(res => {
                this.saveCart({page: 'cart'})
            })
        },hippingCustomPrice() {
            this.shipping_custom_price = !this.reset_shipping ? this.shipping_custom_price : this.shippingPriceWithoutCustom;
            this.$store.commit('SET_SHIPPING_CUSTOM_PRICE', this.reset_shipping ? this.shippingDefaultPriceWithoutCustom : this.shipping_custom_price);
        },
        setShippingCustomPrice() {
            this.checkCartItems()
            this.shipping_custom_price = !this.reset_shipping ? this.shipping_custom_price : this.shippingPriceWithoutCustom;
            let custom_shipping_details= this.reset_shipping ? this.shippingDefaultPriceWithoutCustom : this.shipping_custom_price;
            let is_reset_shipping = this.reset_shipping ? 1 : 0;
            const updatedCustomShippingDetails = custom_shipping_details ? custom_shipping_details : '0';
            this.$store.commit('SET_SHIPPING_CUSTOM_PRICE', {'custom_shipping_details': updatedCustomShippingDetails,'is_reset_shipping': is_reset_shipping} );
            this.reset_shipping = 0;
            this.shipping_custom_price = updatedCustomShippingDetails;
        },
        handleGetCoupon() {
            this.getCoupon(this.code).then(res => {
                this.saveCart({page: 'cart'})
            })
        },
    }
}
</script>

<style>
    .v-select {
        width: 100%;
    }
    .v-select .vs__dropdown-toggle {
        background-color: #fff;
        margin-bottom: 10px;
        height: 30px;
        border-radius: 3px;
    }
    .v-select .vs__actions {
        width: 42px;
    }
    .vs__clear {
        display: none;
    }
    .vs__open-indicator,
    .vs__open-indicator::before {
        border-color: #888 transparent transparent transparent;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        height: 0;
        right: 8px;
        margin-top: -2px;
        position: absolute;
        top: 50%;
        width: 0;
    }
    .vs1__listbox li {
            color: #fff;
    }
    ul.update li {
        text-align: left;
    }
    ul.update li button.update-btn {
        text-transform: capitalize;
        color: #595959;
        background-color: #f2f2f2;
        line-height: 1;
        padding: 0.618em 1em;
        font-weight: 700;
        border-radius: 3px;
        border: 0;
    }
    ul.custom_shipping:after, ul.custom_shipping:before {
        display: none;
    }
    ul.custom_shipping {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    ul.custom_shipping li label:after, ul.custom_shipping li label:before {
        display: none;
    }
    ul.custom_shipping li input[type=number] {
        color: #000;
        width: 5em;
        font-size: 13.3px;
        border: 2px solid #ffffff;
        padding: 5px 5px;
    }
    ul.custom_shipping li label {
        display: flex;
        gap: 5px;
        justify-content: flex-start;
        align-items: center;
        margin: 0;
    }
    ul.shipping_method_list {
        display: flex;
        justify-content: space-between;
    }
    ul.shipping_method_list li {
        flex: 1;
    }
    ul.shipping_method_list li input[type="radio"]{
        margin-right: 4px;
        margin-top: 4px;
        cursor: pointer;
        align-self: flex-start;
    }
    ul.shipping_method_list li p {
        margin-bottom: 10px;
    }
    ul.shipping_method_list li input[type="number"] {
        width: 66px;
        padding: 6px 0;
    }
    ul.shipping_method_list li:last-child {
        text-align: right;
    }
    .v-select .vs__search{
        position: absolute;
    }
    #cartPage .ttn_content .table.shop_table.total_table .notification-tr td {
        border-bottom: 0;
        width: 100%;
        padding: 0;
    }
    #cartPage .ttn_content .table.shop_table.total_table .notification-tr td .notices-wrapper.error {
        padding: 10px 15px;
        text-align: left;
        margin: 9px 12px;
    }
</style>
<!-- test -->
